/**
 * @description  LiveChat component status
 */

export default Object.freeze({
  READY: 'READY', // chat room created and channel available
  TEST_AGENT_AVAILABLE: 'TEST_AGENT_AVAILABLE',
  NOT_CONNECTED: 'NOT_CONNECTED',
  AWAITING: 'AWAITING', // no room or channel
  REMOVED: 'REMOVED', // chat have been removed
  ENDED: 'ENDED', // chat conversation have been ended
})
